module.exports = __webpack_public_path__ + "static/media/white-chevron-right.af583a08.svg";